<template>
    <div>
        <span>{{ $t('feed.fields.deletedCheckinDate') }}</span>
        <strong>{{ getDate(post.pda_checkin.date) }}</strong>

        <span>{{ $t('feed.fields.deletedCheckinValue') }}</span>
        <strong>
            {{ formatNumber(post.pda_checkin.current_value) }}
        </strong>
    </div>
</template>

<script>
import { getDateMixin, formatNumberMixin } from '@/mixins'

export default {
    name: 'Delete',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    mixins: [getDateMixin, formatNumberMixin],
}
</script>

<style></style>
